import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';

const logos = [
  {
    name: 'LinkedIn',
    src: 'https://cdn-icons-png.flaticon.com/512/174/174857.png',
  },
  {
    name: 'Google',
    src: 'https://cdn-icons-png.flaticon.com/512/300/300221.png',
  },
  {
    name: 'Nike',
    src: 'https://cdn-icons-png.flaticon.com/512/732/732229.png',
  },
  {
    name: 'Microsoft',
    src: 'https://cdn-icons-png.flaticon.com/512/732/732221.png',
  },
  {
    name: 'Infosys',
    src: 'https://cdn.brandfetch.io/id2jVuQy_9/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1676271041365',
  },
  {
    name: 'TCS',
    src: 'https://cdn.brandfetch.io/idK2mWG2SJ/w/6000/h/6000/theme/dark/idbAtZJdMk.jpeg?c=1bxid64Mup7aczewSAYMX&t=1743414765671',
  },
];

export default function LogoCollection({heading}) {
  return (
    <Box
      id="logos"
      sx={{
        py: { xs: 4, sm: 8 },
        backgroundColor: (theme) =>
          theme.palette.mode === 'light' ? 'grey.50' : 'grey.900',
      }}
    >
      <Container>
        <Typography
          variant="h6"
          align="center"
          gutterBottom
          sx={{ color: 'text.secondary', mb: 4 }}
        >
          {heading}
        </Typography>

        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="center"
        >
          {logos.map((logo, index) => (
            <Grid item xs={4} sm={2} key={index} sx={{ textAlign: 'center' }}>
              <Avatar
                src={logo.src}
                alt={logo.name}
                sx={{ width: 64, height: 64, mx: 'auto' }}
              />
              <Typography
                variant="body2"
                sx={{ mt: 1, color: 'text.secondary', fontWeight: 500 }}
              >
                {logo.name}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
